import { isReusablePaymentMethodType } from './payment-method-type';
import { ReusablePaymentMethodIdentifier } from './reusable-payment-method/reusable-payment-method-identifier';
import { WalletPaymentMethodIdentifier } from './wallet-payment-method/wallet-payment-method-identifier';

export type PaymentMethodIdentifier = ReusablePaymentMethodIdentifier | WalletPaymentMethodIdentifier;

export const isReusablePaymentMethodIdentifier = (identifier: PaymentMethodIdentifier): identifier is ReusablePaymentMethodIdentifier =>
  !('type' in identifier && !isReusablePaymentMethodType(identifier.type));
